// docs.uipath.com proxies the calculator HTML but the JS bundles are hosted on
// a Cloudflare Pages origin. Webpack's runtime defaults publicPath to '/' on
// the document origin (docs.uipath.com), so dynamic `await import(...)` chunks
// 404. Recover the correct origin from the main bundle's script tag.
declare let __webpack_public_path__: string;

const main = Array.from(document.scripts).find(
  (s) =>
    s.src &&
    /\/static\/js\/main\..+\.chunk\.js$/.test(s.src) &&
    new URL(s.src).origin !== window.location.origin
);

if (main) {
  __webpack_public_path__ = main.src.replace(/static\/js\/[^/]+$/, "");
}

export {};
